module.exports = __webpack_public_path__ + "static/media/nouveau-groupe.a3ed19cc.png";